import React, { useState } from "react"
import { FPaquetesStyle } from "./FWalletStyles"
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    IconButton,
} from "@material-ui/core"
import useAPI from "../../../hooks/useAPI"
import { useDispatch, useSelector } from "react-redux"
import { nuevoWalletDocumentoAction, obtenrWalletPaqueteAction, actualizarWalletDocumentoAction } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import UploadInput from "./../../../global/UploadInput"
import { getBase64 } from "./../../../utils/fileBase64"
import BackDrop from "./../../../global/BackDrop"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "../../../global/ModalBase"
import PostAddIcon from "@material-ui/icons/PostAdd"
import EditIcon from "@material-ui/icons/Edit"
import { catEstatusProceso } from "../../../constant/catEstatusProceso"
const ButtonFWallet = (props) => {
    const { idDocumento = 0, update = false, Nombre = "" } = props
    const { cliente } = useSelector(store => store.cliente)
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    if (update)
        return (
            <div>
                <IconButton aria-label="Editar" onClick={onClick}>
                    <EditIcon />
                </IconButton>
                <FWallet
                    open={open}
                    setOpen={setOpen}
                    idDocumento={idDocumento}
                    update={update}
                    Nombre={Nombre}
                />
            </div>
        )

    return (
        <div>
            <Button
                disabled={cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso === catEstatusProceso.LIQUIDADO ? false : true}
                variant="outlined"
                color="primary"
                onClick={onClick}
                endIcon={<PostAddIcon />}
            >
                Añadir Documento
            </Button>
            <FWallet open={open} setOpen={setOpen} />
        </div>
    )
}

const FWallet = (props) => {
    const { open = false, setOpen = () => { }, idDocumento = 0, update = false, Nombre = "" } = props;
    const { cliente } = useSelector(store => store.cliente)
    const classes = FPaquetesStyle();
    const catTipoWallet = useAPI("Catalog/CatWallet");
    const [tipoDocumento, setTipoDocumento] = useState("0");
    const [file, setFile] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const dispatch = useDispatch();
    const onGuardar = () => {
        if (file.length <= 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Seleccione por lo menos una imagen.",
            })
            return null
        }
        setIsLoad(true);
        file.forEach(async (archivo) => {
            await getBase64(archivo).then((result) => {
                const Logobase64 = String(result).split(",")[1];
                let payload = {
                    idPaquete: cliente?.paquete?.Id_Paquete,
                    Nombre: `${tipoDocumento} - ${archivo.name.split(".")[0]}`,
                    Imagen: Logobase64,
                    ExtensionImagen:
                        archivo.name.split(".")[archivo.name.split(".").length - 1],
                };

                if (update)
                    payload.idDocumento = idDocumento

                dispatch((update) ? actualizarWalletDocumentoAction(payload) : nuevoWalletDocumentoAction(payload)).then((Response) => {
                    setIsLoad(false);
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        })
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "<strong>Atención</strong>",
                            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                        })
                        return null
                    }
                    LimpiarForm();
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                    dispatch(obtenrWalletPaqueteAction({ idPaquete: cliente?.paquete?.Id_Paquete }))
                })
            })
        })
    };
    const LimpiarForm = () => {
        setTipoDocumento("0");
        setFile([]);
        setOpen(false)
    };
    const handleClose = () => {
        setOpen(false);
        LimpiarForm();
    };
    const handleSelecTipoImagen = (event) => {
        setTipoDocumento(event.target.value);
    };
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                titulo={(update) ? `Actulizar archivo ${Nombre}` : `Agregar archivo`}
                handleClose={handleClose}
            />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoImagen">Tipo Documento</InputLabel>
                                <Select
                                    labelId="lTipoImagen"
                                    id="STipoImagen"
                                    name="tipoImagen"
                                    value={tipoDocumento}
                                    onChange={handleSelecTipoImagen}
                                    label="Tipo Documento"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catTipoWallet.map((item, index) => (
                                        <MenuItem
                                            key={item.idCatWallet}
                                            value={item.Descripcion}
                                        >
                                            {`${item.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            {tipoDocumento !== "0" && (
                                <UploadInput
                                    files={file}
                                    accept='.pdf'
                                    isPreview={false}
                                    multiple={(update) ? false : true}
                                    setFiles={setFile}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                onClick={onGuardar}
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                                disabled={file.length > 0 ? false : true}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <BackDrop open={isLoad} />
        </ModalBase>
    );
}
export default ButtonFWallet